export default function isEditorValueEmpty(value) {
  return value && value.document.nodes.size === 1 && value.document.getTexts().size === 1 && value.document.text === '';
}